import React from 'react';
import { CtaButton } from './CtaButton';
import { RatingProof } from './RatingProof';
import { heroMockup } from '../data/productImage';
const chips = ['6 Volumes', '52 Lessons', '300 Pages', '30 · 45 · 60-min versions', '5 Bonuses'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Coach from your phone or laminate it for the boards'];
export function Hero() {
  return <section className="w-full bg-glacier-soft text-ink" data-id="element-139" data-mp="128fs5pz8mpyv">
      <div className="max-w-6xl mx-auto px-5 pt-10 pb-0 sm:pt-14" data-id="element-140" data-mp="xae6qyecaek8">
        <div className="grid items-center gap-10 lg:grid-cols-[.95fr_1.05fr] lg:gap-12" data-id="element-141" data-mp="xb5rfe6eervq">
          <div data-id="element-142" data-mp="s9q8brns6vfz">
            <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-glacier-deep" data-id="element-143" data-mp="sde12olejdtn">
              The 3-Lane Lesson · for figure skating coaches
            </p>
            <h1 className="mt-4 font-display font-bold text-ink text-[38px] leading-[1.06] tracking-tight sm:text-[56px] md:text-[60px]" data-id="element-144" data-mp="3d33fx1m3uzmc">
              One sheet of ice. Three levels.{' '}
              <span className="text-rink-mid" data-id="element-145" data-mp="3j9u2j3pddwnx">Every class already planned.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg text-ink-soft" data-id="element-146" data-mp="3o6ap3tgx82yw">
              Figure Skating Class Ready is the 52-week megapack: six volumes
              with a ready-to-run group lesson for every week of the season — a
              warm-up game, a three-level circuit and an 8-count finish, in 30,
              45 and 60-minute versions. Open the week, set your lanes, coach.
            </p>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-147" data-mp="35aatm8oqihak">
              {chips.map(chip => <li key={chip} className="rounded-full border border-glacier-dark bg-white px-3 py-1.5 text-[11px] font-semibold uppercase tracking-wide text-rink" data-id="element-148" data-mp="2ql68aimn7wy8">
                  {chip}
                </li>)}
            </ul>

            <div className="mt-8 max-w-md" data-id="element-149" data-mp="2ljgzl9mw7vdb">
              <CtaButton data-id="element-150" data-mp="s21h48i0i7ye">Get Figure Skating Class Ready</CtaButton>
            </div>
            <div className="mt-5" data-id="element-151" data-mp="s44ifoom7nif">
              <RatingProof tone="light" data-id="element-152" data-mp="nat8vfsf4smt" />
            </div>
          </div>

          <figure className="relative mx-auto w-full max-w-[640px]" data-id="element-153" data-mp="n9i71lij9uyc">
            <img src={heroMockup.src} alt={heroMockup.alt} width={2340} height={1560} className="aspect-[3/2] w-full rounded-3xl object-cover shadow-mockup ring-1 ring-rink/10" data-id="element-154" data-mp="ichxv1qe0c30" />
          </figure>
        </div>
      </div>

      {/* Rink boards: navy band with the yellow kick-line, echoing the mockup */}
      <div className="mt-12 w-full bg-rink-deep sm:mt-16" data-id="element-155" data-mp="111ew1gownoqi">
        <div className="h-1 w-full bg-amber" aria-hidden="true" data-id="element-156" data-mp="x1ec5gj1elc2" />
        <div className="max-w-6xl mx-auto px-5 py-5" data-id="element-157" data-mp="x37b09nes19i">
          <p className="mx-auto max-w-2xl text-center text-sm text-white/75" data-id="element-158" data-mp="3lu0454qihb1b">
            Written for coaches who run group classes every week — at a club, a
            rink program or on their own. Works alongside any federation&apos;s
            level system. No subscription.
          </p>
          <ul className="mt-3 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/60" data-id="element-159" data-mp="21a4ohgz55rz4">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-160" data-mp="268ofhvsldtyc">
                <span className="h-1.5 w-1.5 rounded-full bg-amber" data-id="element-161" data-mp="2b1r9g51a75f2" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}